import fetchJsonp from "fetch-jsonp";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { INFO_URL } from "../constants/config";
export var AuthContext = React.createContext(undefined);
var initAuth = {
  IS_LOGIN: -1,
  LOGIN_ID: "",
  LOGIN_NICK: "",
  STATION_NO: ""
};
/**
 *
 * @param param0
 * @returns
 */

export default function AuthProvider(_a) {
  var children = _a.children;

  var _b = useState(initAuth),
      auth = _b[0],
      setAuth = _b[1];

  var _c = useState(false),
      visible = _c[0],
      setVisible = _c[1];

  useEffect(function () {
    fetchJsonp(INFO_URL).then(function (response) {
      return response.json();
    }).then(function (response) {
      console.log("response", response);
      setAuth(response.CHANNEL);
      setVisible(true);
    }).catch(function () {
      setAuth(initAuth);
      setVisible(true);
    });
  }, []);
  return React.createElement(AuthContext.Provider, {
    value: auth
  }, visible && children);
}
/**
 *  const {  isLogin,userNick,userId,noteNew  } = useAuth();
 */

export function useAuth() {
  var auth = useContext(AuthContext);
  var isLogin = useMemo(function () {
    return auth.IS_LOGIN === 1;
  }, [auth.IS_LOGIN]);
  var userNick = useMemo(function () {
    return auth.LOGIN_NICK;
  }, [auth.LOGIN_NICK]);
  var userId = useMemo(function () {
    return auth.LOGIN_ID;
  }, [auth.LOGIN_ID]);
  var noteNew = useMemo(function () {
    return parseInt(auth.NOTE_NEW || "0", 10);
  }, [auth.NOTE_NEW]);
  var adPoint = useMemo(function () {
    return parseInt(auth.AD_POINT || "0", 10);
  }, [auth.AD_POINT]);
  var adFrame = useMemo(function () {
    return parseInt(auth.AD_FRAME || "0", 10);
  }, [auth.AD_FRAME]);
  return {
    isLogin: isLogin,
    userNick: userNick,
    userId: userId,
    noteNew: noteNew,
    adPoint: adPoint,
    adFrame: adFrame
  };
}